export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <path d="M6 30h10M4 36h9" stroke="#FACC15" strokeWidth="3" strokeLinecap="round" />
    <path d="M24 12c-4-5-11-6-15-3 3 1 5 3 6 6-2 0-4 1-5 3 4 1 8 0 11-2z" fill="#F8FAFC" />
    <circle cx="30" cy="28" r="13" fill="#84CC16" />
    <path d="M30 22l5.5 4-2 6.5h-7l-2-6.5z" fill="#0B132B" />
    <circle cx="25" cy="24" r="2" fill="#0B132B" />
    <circle cx="35.5" cy="24.5" r="2" fill="#0B132B" />
    <circle cx="30" cy="35" r="2" fill="#0B132B" />
  </svg>
);

export const Logo = ({ size = 36 }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark size={size} />
    <span className="font-display text-2xl tracking-wide leading-none pt-1">
      FLAPPY <span className="text-volt">GOAL</span>
    </span>
  </span>
);

export default Logo;
